import { Button } from "@vds/buttons";
import { Icon } from "@vds/icons";
import moment from "moment";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { getDateForKNOWIAPis, getParentWidgetName, setpathParam , getSelectedTagList} from "../../../global/utility/statisticsUtil";
import { useStatisticContext } from "../contexts/StatisticContext";
import { STATISTICS_TEST_IDS } from "../statisticsConstants";
import AppearanceSelection from "./FilterSections/AppearanceSelection";
import AppSelection from "./FilterSections/AppSelection";
import DateSelection from "./FilterSections/DateSelection";
import LocationSelection from "./FilterSections/LocationSelection";
import ObjectTypeSelection from "./FilterSections/ObjectTypeSelection";

const FilterPanel = () => {
  const {
    activeDatepickerListIndex,
    setActiveDatepickerListIndex,
    appName,
    chart,
    cvAppNames,
    encryptPayload,
    setEncryptPayload,
    endInputDate,
    eventAppColorsClassList,
    eventAppObjectClassList,
    filterlist,
    setFilterList,
    selectedAreas,
    selectedSite,
    setSelectedAreas,
    selectedEventAppObject,
    selectedFloors,
    setSelectedFloors,
    setSelectedSite,
    selectedSubAreas,
    setSelectedSubAreas,
    setActiveAppNameAccordion,
    setActiveDateAccordion,
    activeLocationAccordion,
    setActiveLocationAccordion,
    setAppNameToggleDropdown,
    setEndDateTime,
    setEndInputDate,
    setObjectNameToggleDropdown,
    setShowHideFilter,
    setSiteNameForViewTag,
    setSiteNameToggleDropdown,
    setStartDateTime,
    setStartInputDate,
    filterWidgetOnBasisOfAppSelected,
    getFilteredRoiListArray,
    getTagListForEncryptAPI,
    mapRoiListBasedOnSites,
    roiListItem,
    showHideFilter,
    showObjectTypeDropdown,
    siteList,
    sites,
    startInputDate,
    siteReducer,
    pendingAppChange,
    pendingTagPayload
  } = useStatisticContext();

  const showColorAppearanceDetails = window.REACT_APP_STATS_COLOR_APPEARANCE;

  const [searchParams, setSearchParams] = useSearchParams();
  const isCortexBarShown = useSelector((state) => state?.chatbot?.isNluEnabled);

  const handleFilterApply = (event) => {
    let widgetAxisType = "hh:mmA";
    let widgetFixedIntervl = "1m";
    let eeChartWidgetinterval = "1h";
    let filterDate = "Today";

    const diffOfDatesInDays = moment(endInputDate).diff(moment(startInputDate), "days");
    if (diffOfDatesInDays < 2) {
      widgetAxisType = "hh:mmA";
      widgetFixedIntervl = "1m";
      eeChartWidgetinterval = "15m";
      filterDate = new Date(startInputDate).getDate() != new Date().getDate() ? " Yesterday" : "Today";
    } else if (diffOfDatesInDays >= 2 && diffOfDatesInDays <= 7) {
      widgetAxisType = "ddd DD";
      widgetFixedIntervl = "10m";
      eeChartWidgetinterval = "6h";
      filterDate = "Last 7 days";
    } else if (diffOfDatesInDays > 7 && diffOfDatesInDays <= 30) {
      widgetAxisType = "DD MMM";
      widgetFixedIntervl = "1h";
      eeChartWidgetinterval = "1d";
      filterDate = "Last 30 days";
    } else if (diffOfDatesInDays > 30 && diffOfDatesInDays <= 180) {
      widgetAxisType = "DD MMM";
      widgetFixedIntervl = "30d";
      eeChartWidgetinterval = "30d";
      filterDate = "Last 6 months";
    } else if (diffOfDatesInDays > 180) {
      widgetAxisType = "MMM YYYY";
      widgetFixedIntervl = "30d";
      eeChartWidgetinterval = "30d";
      filterDate = diffOfDatesInDays < 365 && diffOfDatesInDays > 180 ? "Year to date" : "Last year";
    } else {
      widgetAxisType = "hh:mmA";
      widgetFixedIntervl = "1m";
      eeChartWidgetinterval = "1h";
    }

    if (activeDatepickerListIndex == 1) {
      filterDate = new Date(startInputDate).toLocaleDateString() + " To " + new Date(endInputDate).toLocaleDateString();
    }

    pendingAppChange.current = false;
    const deferredTagPayload = pendingTagPayload.current;
    pendingTagPayload.current = {};
    setShowHideFilter(false);
    filterWidgetOnBasisOfAppSelected(appName);
    setEncryptPayload({
      ...encryptPayload,
      ...deferredTagPayload,
      endDate: getDateForKNOWIAPis(activeDatepickerListIndex == 1 ? new Date(endInputDate) : new Date(Date.now() )),
      extendedendDate: getDateForKNOWIAPis(activeDatepickerListIndex == 1 ? new Date(endInputDate) : new Date(Date.now() - 1 * 60 * 1000)),
      startDate: getDateForKNOWIAPis(new Date(startInputDate)),
      xAxisDateFormat: widgetAxisType,
      eeFixedInterval: eeChartWidgetinterval,
      histogram_fixedinterval: widgetFixedIntervl,
      tagIdList: getTagListForEncryptAPI(selectedSubAreas, selectedAreas, selectedFloors, selectedSite, siteList)?.join(","),
      objectClass: selectedEventAppObject,
      eventfield: "fields." + getParentWidgetName(appName, cvAppNames) + ".resolutionTime",
      eventfieldForPriority: "fields." + getParentWidgetName(appName, cvAppNames) + ".severity"
    });
    var siteListFromRoiList = [];

    if (selectedAreas.length > 0) {
      var floorids = siteReducer.floors.filter((g) => {
        return selectedAreas.map((y) => (y?.tagid === undefined ? y?.tagids[0] : y?.tagid[0])).indexOf(g.id) !== -1;
      });
      siteListFromRoiList = siteReducer.sites.filter((f) => {
        return floorids.map((j) => j.tagids[0]).indexOf(f.id) > -1;
      });
    } else if (selectedFloors.length > 0) {
      siteListFromRoiList = siteReducer.sites.filter((f) => {
        const getFloorId = (floor) => {
          if (floor?.tagid !== undefined) return floor.tagid[0];
          if (Array.isArray(floor?.tagids[0])) return floor.tagids[0][0];
          return floor?.tagids[0];
        };
        return selectedFloors.map(getFloorId).indexOf(f.id) > -1;
      });
    } else if (selectedSite.length > 0) {
      siteListFromRoiList = siteReducer.sites.filter((f) => {
        return selectedSite.map((j) => j?.id).includes(f.id);
      });
    }
    setSelectedSite(selectedSite);

    const selectedLocationList = getSelectedTagList(selectedSubAreas, selectedAreas, selectedFloors, selectedSite, siteReducer?.sites);
    const locationList = selectedLocationList.map(m => m.id);
    let rlist = roiListItem.filter(f => f.customdata?.statisticstagids && f.customdata.statisticstagids.some(s => locationList.includes(s)));

    let result = mapRoiListBasedOnSites(rlist, appName);

    getFilteredRoiListArray(result, true);

    // if(filterlist["Day"] === "Custom"){
    setFilterList({
      ...filterlist,
      Day: filterDate,
      Site: selectedSite.map((u) => u.name),
      App: appName,
      Floor: selectedFloors.map((item) => item.name),
      Area: selectedAreas.map((item) => item.name),
      Subarea: selectedSubAreas.map((item) => item.name),
      ...(selectedEventAppObject && selectedEventAppObject !== "All Objects" ? { Object: selectedEventAppObject } : {})
    });

    setSearchParams({ appName: setpathParam(appName)});
  };

  const handleFilterClose = (event) => {
    setShowHideFilter(false);
  };

  if (!showHideFilter) return <></>;

  return (
    <div
      className="filterTowerMain"
      style={{ "--sticky-banner-bottom": isCortexBarShown ? "100px" : "0px" }}
    >
      <div className="filterBarMainInnerContainer">
        <div
          className="filterTowerHideFilterMain"
          style={{ cursor: "pointer" }}
          data-testid={STATISTICS_TEST_IDS.FILTER_PANEL_CLOSE}
          onClick={() => {
            setShowHideFilter(false);
            setActiveLocationAccordion(null);
            setActiveDateAccordion(null);
            setActiveAppNameAccordion(null);
            setAppNameToggleDropdown(false);
            setObjectNameToggleDropdown(false);
            setSiteNameToggleDropdown(false);
          }}
        >
          <div
            style={{
              marginRight: "5px",
              position: "relative",
              right: "35px"
            }}
          >
            {" "}
            <div style={{ float: "right" }}>
              <Icon name="close" />
            </div>{" "}
          </div>
          <h5>
            <b>Filter</b>
          </h5>
        </div>
        <div
          style={{
            overflow: "auto",
            height: "100%",
            maxHeight: activeLocationAccordion === 4 ? "calc(100vh - 150px)" : "unset",
            position: "relative"
          }}
        >
          <AppSelection />
          {showObjectTypeDropdown && eventAppObjectClassList.length > 0 && (
            <>
              <ObjectTypeSelection />
            </>
          )}
          <DateSelection />
          {showColorAppearanceDetails && eventAppColorsClassList.length > 0 && <AppearanceSelection />}

          {(appName !== "All Apps" || sites.length === 1) && (
            <>
              <LocationSelection />
            </>
          )}
        </div>

        <div className="mainFilterFooter">
          <Button
            use="primary"
            size="large"
            disabled={endInputDate.length <= 0}
            onClick={(evt) => handleFilterApply(evt)}
          >
            Apply
          </Button>
          <Button
            use="secondary"
            size="large"
            onClick={(evt) => handleFilterClose(evt)}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;
